import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import Overlay from 'ol/Overlay';
import {toStringHDMS} from 'ol/coordinate';
import TileLayer from 'ol/layer/Tile';
import {toLonLat} from 'ol/proj';
import {defaults as defaultControls, ScaleLine} from 'ol/control';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import {get as getProjection} from 'ol/proj';
import {getTopLeft, getWidth} from 'ol/extent';

var osm = new TileLayer({
  source: new OSM({url:'https://tile.openstreetmap.org/{z}/{x}/{y}.png'})
});

const projection = getProjection('EPSG:3857');
const projectionExtent = projection.getExtent();
const size = getWidth(projectionExtent) / 256;
const resolutions = new Array(19);
const matrixIds = new Array(19);
for (let z = 0; z < 19; ++z) {
  // generate resolutions and matrixIds arrays for this WMTS
  resolutions[z] = size / Math.pow(2, z);
  matrixIds[z] = 'EPSG:900913:'+z;
}





  var wmtsLayer = new TileLayer({
      opacity: 0.7,
      source: new WMTS({
        attributions: 'Derived product from&shy; the <a href="https://www.gebco.net/data_and_products/gridded_bathymetry_data/">GEBCO 2021 Grid</a>, made with <a href="https://www.openstreetmap.de/">OpenStreetMap</a> by OpenDEM',
		  url: 'https://geoserver.openseamap.org/geoserver/gwc/service/wmts',
        layer: 'gebco2021:gebco_2021',
        matrixSet: 'EPSG:900913',
        format: 'image/png',
        projection: 'EPSG:900913',
        tileGrid: new WMTSTileGrid({
          origin: getTopLeft(projectionExtent),
          resolutions: resolutions,
          matrixIds: matrixIds,
        }),
        style: 'default',
        wrapX: true,
      }),
    });

// http://depth.openseamap.org/geoserver/gwc/service/wmts?layer=gebco2021:gebco_2021&style=&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/jpeg&TileMatrix=EPSG:900913:2&TileCol=2&TileRow=1

/*

var wmsLayerSource = new ImageWMS({
  url: 'http://osm.franken.de:8080/geoserver/gebco/wms',
  // gruppenlayer
  params: {'LAYERS': 'gebco_2021'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',
  attributions: ' Derived product from the <a href="https://www.gebco.net/data_and_products/gridded_bathymetry_data/">GEBCO 2021 Grid</a>, made with <a href="https://www.openstreetmap.de/">OpenStreetMap</a> by OpenDEM'
});

*/


/*
var wmsLayerSource = new ImageWMS({
  url: 'http://osm.franken.de:8080/geoserver/gebco/wms',
  // gruppenlayer
  params: {'LAYERS': 'gebco_2021'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',
  attributions: ' Derived product from the <a href="https://www.gebco.net/data_and_products/gridded_bathymetry_data/">GEBCO 2021 Grid</a>, made with <a href="https://www.openstreetmap.de/">OpenStreetMap</a> by OpenDEM'
});
*/

/*

var wmsLayer = new ImageLayer({
  source: wmsLayerSource 
});

*/ 

/*

var wmsLayerSource = new ImageWMS({
  url: 'https://geoserver.openseamap.org/geoserver/gebco2021/wms',
  // gruppenlayer
  params: {'LAYERS': 'gebco2021:gebco_2021'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',
  attributions: ' Derived product from the <a href="https://www.gebco.net/data_and_products/gridded_bathymetry_data/">GEBCO 2021 Grid</a>, made with <a href="https://www.openstreetmap.de/">OpenStreetMap</a> by OpenDEM'
});




var wmsLayer = new ImageLayer({
  source: wmsLayerSource 
});

*/

/*

var wmsLayerSource2 = new ImageWMS({
  url: 'https://www.opendem.info/geoserver/opendem/wms',
  params: {'LAYERS': 'opendem:marine_labels'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',  
});

var wmsLayer2 = new ImageLayer({
  source: wmsLayerSource2
});

*/

/*

var wmsLayerSourceNew = new ImageWMS({
  url: 'https://geoserver.openseamap.org/geoserver/gebco2021/wms',
  params: {'LAYERS': 'layers=gebco2021:gebco2021_contour'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',  
});

var wmsLayerNew = new ImageLayer({
  source: wmsLayerSourceNew
});

*/

var wmsLayerSource = new ImageWMS({
  url: 'https://geoserver.openseamap.org/geoserver/gebco2021/wms',
  params: {'LAYERS': 'layers=gebco2021:gebco_2021_poly'},
  serverType: 'geoserver',
  crossOrigin: 'anonymous',  
});

var wmsLayer = new ImageLayer({
  source: wmsLayerSource
});


/**
 * Elements that make up the popup.
 */
var container = document.getElementById('popup');
var content = document.getElementById('popup-content');
var closer = document.getElementById('popup-closer');


/**
 * Create an overlay to anchor the popup to the map.
 */
var overlay = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250
  }
});


/**
 * Add a click handler to hide the popup.
 * @return {boolean} Don't follow the href.
 */
closer.onclick = function() {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};

var view = new View({
  center: [0, 0],
  zoom: 1
});

var scaleControl = new ScaleLine({
});

var map = new Map({
  // layers: [osm, wmtsLayer,wmsLayer2],
  layers: [osm, wmtsLayer],
  target: 'map',
  overlays: [overlay],
  view: view,
      controls: defaultControls().extend([
    scaleControl
  ]),
});


map.on('singleclick', function(evt) {
  var viewResolution = /** @type {number} */ (view.getResolution());
  var url = wmsLayerSource.getFeatureInfoUrl(
    evt.coordinate, viewResolution, 'EPSG:3857',
    {'INFO_FORMAT': 'application/json'});
  if (url) {
    fetch(url)
      .then(function (response) {
	  
	  return response.text();


	  })
      .then(function (json) {		
		 var fi = JSON.parse(json);	 	 
  	 
		   var coordinate = evt.coordinate;  
		     var hdms = toStringHDMS(toLonLat(coordinate));
  	  content.innerHTML = '<p>Depth class: '+ fi.features[0].properties.amax + ' m till ' + fi.features[0].properties.amin + ' m<br/> at coordinate:</p><code>'+hdms+'</code>';
  overlay.setPosition(coordinate);
      });
  }
});